import { OtherTextField } from '@/pages/onboarding/OtherTextField';
import { QuestionLabel } from '@/pages/onboarding/QuestionLabel';
import { SpecialtyField } from '@/pages/onboarding/SpecialtyField';
import type { OnboardingStepProps } from '@/pages/onboarding/onboarding.types';
import { PROFESSION_OPTIONS, matchOption } from '@/pages/onboarding/onboardingOptions';
import { ChoiceCard, ChoiceCardGroup, Grid, Icon, Stack } from '@careflux/primitives';
import { Controller, useWatch } from 'react-hook-form';

const PROFESSIONS = PROFESSION_OPTIONS.map((option) => option.value);

export const ProfessionStep = ({ copy, control }: OnboardingStepProps) => {
  const profession = useWatch({ control, name: 'profession' });

  return (
    <Stack as="section" gap="lg">
      <Controller
        name="profession"
        control={control}
        render={({ field }) => (
          <Stack gap="sm">
            <QuestionLabel id="profession-label">{copy.profession.question}</QuestionLabel>
            <Grid asChild columns={{ base: 2, sm: 3 }} gap="sm">
              <ChoiceCardGroup
                aria-labelledby="profession-label"
                value={field.value ?? ''}
                onValueChange={(value) => {
                  const next = matchOption(PROFESSIONS, value);
                  if (next) field.onChange(next);
                }}
              >
                {PROFESSION_OPTIONS.map(({ value, icon }) => (
                  <ChoiceCard
                    key={value}
                    id={`profession-${value}`}
                    value={value}
                    label={copy.profession.options[value]}
                    icon={<Icon name={icon} />}
                  />
                ))}
              </ChoiceCardGroup>
            </Grid>
          </Stack>
        )}
      />
      {profession === 'other' && (
        <OtherTextField
          name="professionOther"
          id="profession-other-text"
          label={copy.profession.otherLabel}
          placeholder={copy.profession.otherPlaceholder}
          control={control}
        />
      )}
      {profession === 'doctor' && <SpecialtyField copy={copy} control={control} />}
    </Stack>
  );
};
